import AxiosBusiness from '@/services/api/business/axios_business'

export default {
  // Billable endpoints
  createBillable: (data) => {
    return AxiosBusiness.post('billable', data)
  },

  updateBillable: (billableId, data) => {
    return AxiosBusiness.put(`billable/${billableId}`, data)
  },

  deleteBillable: (billableId) => {
    return AxiosBusiness.delete(`billable/${billableId}`)
  },

  getBillable: (billableId) => {
    return AxiosBusiness.get(`billable/${billableId}`)
  },

  getAllBillablesByCustomer: (customerId, params) => {
    return AxiosBusiness.get(`billable/customer/${customerId}`, { params })
  },

  getAllBillablesByDeliverable: (deliverableId, params) => {
    return AxiosBusiness.get(`billable/deliverable/${deliverableId}`, { params })
  },
}
